import React from 'react';
import PropTypes from 'prop-types';

function Root({ children }) {
  return (
    <div>
      { children }
    </div>
  );
}

Root.propTypes = {
  children: PropTypes.node,
};

Root.defaultProps = {
  children: null,
};


export default Root;



// WEBPACK FOOTER //
// ./src/Root.js